import React, { createContext, useContext, useEffect } from 'react';
import { useForm } from 'react-final-form';
import { useHistoryStackSelector } from '../FormsStateMachine/stateSelectors';
import { useCarleadTimeTracking } from '../hooks/useTimeTracking';
import { CarleadWizard } from './CarleadWizard';
export const MachineServiceContext = /*#__PURE__*/createContext(undefined);
export function useFormMachine() {
  //@ts-expect-error
  return useContext(MachineServiceContext);
}
export function CarleadCreationForm(_ref) {
  let {
    children,
    carleadForm,
    options,
    submitHandler,
    topContent,
    bottomContent,
    machineService
  } = _ref;
  useCarleadTimeTracking({
    page: (options === null || options === void 0 ? void 0 : options.name) || 'StepCompound'
  });
  return /*#__PURE__*/React.createElement(MachineServiceContext.Provider, {
    value: machineService
  }, /*#__PURE__*/React.createElement(CarleadWizard, {
    carleadForm: carleadForm,
    options: options,
    submitHandler: submitHandler,
    topContent: topContent,
    bottomContent: bottomContent,
    machineService: machineService
  }, /*#__PURE__*/React.createElement(ResetFormErrors, null), children));
}
/**
 * Clears the form submitFailed state if the context
 * stack changes (the state machine has transition to a new state)
 * this remove <FieldError /> from the screen
 * @returns null
 */

function ResetFormErrors() {
  const {
    getState,
    reset
  } = useForm();
  const changed = useHistoryStackSelector();
  useEffect(() => {
    const {
      values,
      submitFailed
    } = getState();

    if (submitFailed) {
      reset(values);
    }
  }, [changed, getState, reset]);
  return null;
}